import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import { reducer as productReducer } from './product';
import { reducer as authReducer } from './auth';
import { reducer as dashboardReducer } from './dashboard';
import { reducer as courseReducer } from './course';
import { reducer as commentsReducer } from './comments';
import { reducer as userProfileReducer } from './userProfile';
import { reducer as annotationsReducer } from './annotations';
import { reducer as appointmentsReducer } from './appointments';

const createRootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    product: productReducer,
    auth: authReducer,
    dashboard: dashboardReducer,
    course: courseReducer,
    comments: commentsReducer,
    userProfile: userProfileReducer,
    annotations: annotationsReducer,
    appointments: appointmentsReducer,
  });

export default createRootReducer;
